var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L28.124 9V23L16 30L3.876 23V9L16 2Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 13.6V11.85H21.1V9.35H10.9V11.85H14.8V13.59C11.35 13.76 8.75 14.45 8.75 15.28C8.75 16.11 11.35 16.8 14.8 16.98V22.35H17.2V16.98C20.64 16.8 23.25 16.11 23.25 15.28C23.25 14.45 20.64 13.76 17.2 13.6ZM16 15.7C12.35 15.7 10.35 15.15 10.35 15.15C10.35 15.15 12.35 14.6 16 14.6C19.65 14.6 21.65 15.15 21.65 15.15C21.65 15.15 19.65 15.7 16 15.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.8ef8fbf3893e59b2ed2d82b26835b2a4.svg";
export { ForwardRef as ReactComponent };